<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 대한민국 일자리 으뜸기업에 세 번째 선정</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                       <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_06.png"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌(대표 권대호)이 지난 7월 9일 세종시 세종컨벤션센터에서 5회째 개최된 ‘2022 대한민국 일자리 으뜸기업 인증식’에서 3회째 선정되며
                                일자리 창출 기여의 공을 인정받았다고 11일 밝혔다.
                                <br>
                                <br>
                                고용노동부가 주관하는 대한민국 일자리 으뜸기업 인증은 고용창출 실적과 고용의 질이 우수한 100개 기업을 선정하는 제도다. 에듀윌은 지난 2019년,
                                2020년에 이어 올해까지 세 번째 일자리 으뜸기업에 선정됐다. 일자리 으뜸기업 인증제도가 지난 2018년 시작돼 올해 5회째를 맞이하고 있는 가운데,
                                에듀윌은 벌써 세번째 인증을 받아 양질의 일자리 창출로 사회에 기여한 공로를 높이 평가 받고 있다는 게 에듀윌의 설명이다.
                                <br>
                                <br>
                                에듀윌은 지난 2019년 6월부터 주4일 근무제를 도입해 실질 노동시간을 대폭 단축했으며, 2020년에 비해 2021년 18%의 고용증가율을 기록했고
                                2021년 기준 비정규직 인턴 직원을 100% 정규직으로 전환했다.
                                <br>
                                <br>
                                또 에듀윌은 호텔급 안마시설인 ‘힐링큐브’, 사내 심리상담실 ‘마음, 쉼’, 로봇 바리스타 ‘윌리’, 장기근속 휴가제도 등을 통해 일과 생활의 균형을 실천하고
                                있다. 신입사원 초임과 인턴 사원 임금을 꾸준히 인상해 왔으며, 정기적인 직원만족도조사를 통한 업무 환경 개선, 평가제도 개편 및 연봉 평가 방식 개선 등을
                                활발히 진행하며 노사 상생 방안 마련에도 적극적으로 나서고 있다.
                                <br>
                                <br>
                                권대호 에듀윌 대표는 “’고객의 꿈, 직원의 꿈, 지역사회의 꿈을 실현한다’는 회사의 비전 중직원의 꿈을 실현하기 위한 노력을 높게 평가받았기 때문에 이번
                                일자리 으뜸기업에 선정됐다고 생각한다”며 “에듀윌은 앞으로도 회사와 직원이 함께 성장할 수 있는 다양한 제도를 만들어 대한민국 일자리 으뜸기업이라는 명성에
                                걸맞게 고객의 꿈과 직원의 꿈, 지역사회의 꿈을 이루는 기업이 되겠다”고 말했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news5" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, ESG 평가서 우수 등급 획득…교육업계 최고 수준</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news7" data-value="315283">
                                        <strong>다음</strong>
                                        <span>'베스트셀러 1위’ 휩쓴 에듀윌 토익 교재, 수험생도 에듀윌에 눈떴다!</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
